import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Message from 'yoda-site-components/lib/components/Messages/Message/Message';
import { messageTypes } from 'yoda-site-components/lib/components/Messages/Messages.config';
import LoadingAction from 'yoda-site-components/lib/actions/LoadingAction';
import { GENERIC_ERROR_MSG } from '../../common/Constants';

export class AddToCartInterstitalLazyError extends Component {
    static propTypes = {
        actions: PropTypes.oneOfType([PropTypes.object]),
    };

    static defaultProps = {
        actions: {},
    };

    componentDidMount() {
        this.props.actions.removeLoader();
    }

    render() {
        return <Message title={GENERIC_ERROR_MSG} type={messageTypes.error} hasClose={false} />;
    }
}

const mapDispatchToProps = (dispatch) => ({
    actions: bindActionCreators(
        {
            removeLoader: LoadingAction.removeLoader,
        },
        dispatch
    ),
});

export default connect(null, mapDispatchToProps)(AddToCartInterstitalLazyError);
